import {
  USEFUL_LINK_FETCH,
  USEFUL_LINK_ADD,
  USEFUL_LINK_UPDATE,
  USEFUL_LINK_DELETE,
  AUTH_LOG_OUT_USER,
} from "actions/types";
import { AUTH_LOG_OUT_PROVIDER } from "containers/auth/Pet_Services_Portal/actions";
import _ from "lodash";

const INITIAL_STATE = {
  entries: [],
  fetched: false,
};

export default function UsefulLinksReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case USEFUL_LINK_FETCH:
      return {
        ...state,
        entries: _.uniqWith([...state.entries, ...action.payload], _.isEqual),
        fetched: true,
      };
    case USEFUL_LINK_ADD:
      return {
        ...state,
        entries: _.sortBy(
          [...state.entries, action.payload],
          "dateCreated"
        ).reverse(),
      };
    case USEFUL_LINK_UPDATE:
      return {
        ...state,
        entries: _.sortBy(
          [
            ...state.entries.filter(
              (entry) => entry._id !== action.payload._id
            ),
            action.payload,
          ],
          "dateCreated"
        ).reverse(),
      };
    case USEFUL_LINK_DELETE:
      return {
        ...state,
        entries: state.entries.filter((entry) => entry._id !== action.payload),
      };
    case AUTH_LOG_OUT_USER:
    case AUTH_LOG_OUT_PROVIDER:
      return INITIAL_STATE;
    default:
      return state;
  }
}
